'use client'

import { useEffect } from 'react'
import { getBugsnagClient } from '@/lib/bugsnag/bugsnag'

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error('Global error:', error)
    getBugsnagClient()?.notify(error)
  }, [error])

  return (
    <>
      <h2>Something went wrong!</h2>
      <button onClick={() => reset()}>Try again</button>
    </>
  )
}
